import type { ReactNode } from "react"

interface Props {
  title: string
  subtitle?: ReactNode
  step?: number
  totalSteps?: number
  onBack?: () => void
  backLabel?: string
  children?: ReactNode
}

export default function JoinCard({
  title,
  subtitle,
  step,
  totalSteps,
  onBack,
  backLabel,
  children,
}: Props) {
  const showProgress = step !== undefined && totalSteps !== undefined

  return (
    <div className="join-card card border-0 shadow-sm">
      {showProgress && (
        <div className="join-progress">
          <div className="progress" role="progressbar" aria-valuenow={step} aria-valuemin={1} aria-valuemax={totalSteps}>
            <div className="progress-bar" style={{ width: `${(step / totalSteps) * 100}%` }} />
          </div>
          <p className="join-step-label">
            Step {step} of {totalSteps}
          </p>
        </div>
      )}

      <div className="card-body p-4">
        <p className="join-wordmark">Artemis</p>
        <h1 className="join-title">{title}</h1>
        {subtitle && <p className="join-subtitle">{subtitle}</p>}

        {children}

        {onBack && (
          <button type="button" className="btn btn-link join-back" onClick={onBack}>
            {backLabel || "Back"}
          </button>
        )}
      </div>
    </div>
  )
}
